import permissions from "../../data/permissions"

export default [
    {
        name: "GoodsIssueVouchersList",
        path: "goods-issue-vouchers",
        component: () => import('./../../views/warehouse/GoodsIssueListView'),
        meta: { requiresAuth: true, authorization: permissions.good_issue.index }
    },
    {
        name: "GoodsIssueVoucherCreate",
        path: "goods-issue-voucher",
        component: () => import('./../../views/warehouse/GoodsIssueCreateView'),
        meta: { requiresAuth: true, authorization: permissions.good_issue.create }
    },
    {
        name: "GoodsIssueVoucherDisplay",
        path: "goods-issue-voucher/:id",
        component: () => import('./../../views/warehouse/GoodsIssueDisplayView'),
        meta: { requiresAuth: true, authorization: permissions.good_issue.read }
    },
    {
        name: "GoodsIssueVoucherEdit",
        path: "goods-issue-voucher/:id/edit",
        component: () => import('./../../views/warehouse/GoodsIssueEditView'),
        meta: { requiresAuth: true, authorization: permissions.good_issue.update }
    }
]